export const handleClickForKeyboard = (
  onClick?: (e?: React.UIEvent) => void,
) => {
  if (!onClick) {
    return undefined;
  }

  return (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };
};
